import React from 'react';
import { LockIcon } from 'lucide-react';
import { PlanTier } from '../../types/entitlements';
interface UpsellBadgeProps {
  variant?: 'inline' | 'chip' | 'tag';
  plan: PlanTier;
  size?: 'sm' | 'md';
  onClick?: () => void;
}
export function UpsellBadge({
  variant = 'chip',
  plan,
  size = 'sm',
  onClick
}: UpsellBadgeProps) {
  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-3 py-1'
  };
  const variantClasses = {
    inline: 'inline-flex',
    chip: 'inline-flex rounded-full',
    tag: 'inline-flex rounded'
  };
  const planColors = {
    Growth: 'bg-blue-100 text-blue-700 border-blue-200',
    Scale: 'bg-purple-100 text-purple-700 border-purple-200',
    Enterprise: 'bg-gradient-to-r from-yellow-400 to-orange-500 text-white border-orange-600'
  };
  return <button onClick={onClick} className={`${variantClasses[variant]} ${sizeClasses[size]} items-center gap-1 font-semibold border ${planColors[plan as keyof typeof planColors] || 'bg-gray-100 text-gray-700 border-gray-200'} hover:opacity-80 transition-opacity`} data-id="element-3570">
      <LockIcon className={size === 'sm' ? 'w-3 h-3' : 'w-4 h-4'} data-id="element-3571" />
      {plan}
    </button>;
}